import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { Delivery } from '../../models';
import { DeliveryStatusComponent } from '../deliveries/delivery-status.component';

@Component({
  selector: 'product-name-cell',
  template: ` <div
    class="text-base h-full flex flex-col justify-center items-center"
  >
    <delivery-status
      [delivery]="{ status: delivery.status, due: delivery.due }"
    ></delivery-status>
  </div>`,
  standalone: true,
  imports: [DeliveryStatusComponent]
})
export class DeliveryStatusCellComponent implements AgRendererComponent {
  params: any;
  delivery: Delivery;

  agInit(params: any): void {
    this.params = params;
    this.delivery = this.params.data.delivery;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.delivery = this.params.data.delivery;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
